module.exports = __webpack_public_path__ + "static/img/404.8b0042d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.png
// module id = zAji
// module chunks = 23